import type { MapDispatchToProps, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import type { FormStateMap } from 'redux-form';
import { change, getFormAsyncErrors } from 'redux-form';
import {
  AGENCY_FORM_SECTION,
  agencyFields,
  CONTACT_INFO_FORM_SECTION,
  contactFields,
} from '../constants/formFields';
import type { Country } from '../models';
import AgentInformationFormSection from './AgentInformationFormSection';
import type { PhoneType } from './contact-form/Phone';

const { AGENT_EMAIL, AGENT_PHONE } = agencyFields;
const { EMAIL, EMERGENCY_PHONE, PHONE } = contactFields;

interface ConnectedState {
  hasAsyncAgentPhoneError: boolean;
  hasOtherAsyncErrors: boolean;
}

const mapStateToProps: MapStateToProps<ConnectedState, { form: string }, { form: FormStateMap }> = (
  state,
  { form },
) => {
  const asyncErrors: any = getFormAsyncErrors(form)(state);
  const asyncAgentInformationFormErrors =
    asyncErrors && asyncErrors[AGENCY_FORM_SECTION] ? asyncErrors[AGENCY_FORM_SECTION] : {};
  const asyncContactFormErrors =
    asyncErrors && asyncErrors[CONTACT_INFO_FORM_SECTION]
      ? asyncErrors[CONTACT_INFO_FORM_SECTION]
      : {};
  const hasAsyncAgentPhoneError = asyncAgentInformationFormErrors[AGENT_PHONE] !== undefined;
  const hasAsyncAgentEmailError = asyncAgentInformationFormErrors[AGENT_EMAIL] !== undefined;
  const hasAsyncContactFormEmailError = asyncContactFormErrors[EMAIL] !== undefined;
  const hasAsyncContactFormPhoneError = asyncContactFormErrors[PHONE] !== undefined;
  const hasAsyncEmergencyPhoneError = asyncContactFormErrors[EMERGENCY_PHONE] !== undefined;

  const hasOtherAsyncErrors =
    hasAsyncAgentEmailError ||
    hasAsyncContactFormEmailError ||
    hasAsyncContactFormPhoneError ||
    hasAsyncEmergencyPhoneError;

  return {
    hasAsyncAgentPhoneError,
    hasOtherAsyncErrors,
  };
};

interface ConnectedDispatch {
  onCountryChange: (phoneType: PhoneType) => void;
}

const mapDispatchToProps: MapDispatchToProps<
  ConnectedDispatch,
  {
    form: string;
    countries: Country[];
  }
> = (dispatch, { form }) => ({
  onCountryChange(phoneType: PhoneType) {
    dispatch(change(form, `${AGENCY_FORM_SECTION}.${phoneType}`, ''));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentInformationFormSection);
